import BaseComponent from '../../base/base_component';
import DOM, {ElementSize} from '../../utils/dom';
import Device from '../../utils/device/device';
import {SYSTEM_EVENTS} from '../../events/events';
import { BaseComponentParams } from '../../base/base_component_interface';


export interface GameBodyComponentBaseParams extends BaseComponentParams {
    gameType: number;
    gameGroupId: number;
    isResizable: boolean;
    gameSize: ElementSize;
    gameProviderCssClassName: string;
    additionalCssClasses: string[];
}

export default abstract class GameBodyComponentBase extends BaseComponent {

    _selector = 'cgp-game-body';

    protected abstract _setGameBodySize(gameSize: ElementSize): void;

    private _params: GameBodyComponentBaseParams;

    protected init(params: GameBodyComponentBaseParams) {
        super.init(params);

        if(!params.gameProviderCssClassName) {
            this.throwArgumentExpected('29', 'init', 'gameProviderCssClassName');
        }

        this._params = params;

        this.addClass('cgp-game-iframe-container');
        this.addClass(params.gameProviderCssClassName);
        this.addClass('cgp-game-' + params.gameType);

        this._appendAdditionalClasses(params.additionalCssClasses);
        this._subscribe();
    }

    private _appendAdditionalClasses(classes: string[]) {
        classes = classes || [];

        classes.forEach(cls => {
            this.addClass(cls);
        });
    }

    _isGameResizable() {
        return this._params.isResizable && !Device.os.isMobileOS;
    }

    _subscribe() {
        if (this._isGameResizable()) {
            this.onSystemEvent(SYSTEM_EVENTS.SCREEN_RESIZE_CHANGED, () => {
                this.serviceFactory.observableFactoryService().fromTimeout(200).forEach(() => {
                    this._resizeGame();
                });
            });

        }

    }

    private _computeAvailableSpace(): ElementSize {
        return this.serviceFactory.windowService().getComputedSize(DOM.querySelector('.cgp-game-body-container'));
    }

    private _resizeGame() {
        let availableSpace = this._computeAvailableSpace();


        let gameMax = {...this._params.gameSize};

        let output = {...this._params.gameSize};

        let calculateAspectRatioFit = (srcWidth, srcHeight, maxWidth, maxHeight) => {
            let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

            return {
                width: Math.floor(srcWidth * ratio),
                height: Math.floor(srcHeight * ratio)
            };
        };

        if (gameMax.width >= availableSpace.width || gameMax.height >= availableSpace.height) {
            output = calculateAspectRatioFit(gameMax.width, gameMax.height, availableSpace.width, availableSpace.height);
        }

        this._setGameBodySize(output);

    }

    onAppendedToDOM() {
        super.onAppendedToDOM();

        if (this._isGameResizable()) {
            this._resizeGame();
        } else {
            this._setGameInitialSize();
        }
    }

    _setGameInitialSize() {
        if (!Device.os.isMobileOS) {
            this._setGameBodySize(this._params.gameSize);
        }
    }

    updateGameSize() {
        this._resizeGame();
    }

    stopAutoplay() {
        // to be overridden in extended classes
    }
}